module.exports = __webpack_public_path__ + "media/src/images/icons/people/add-ff3f5378bcd3cd45af1207f08627034b.svg";